export default {
  SET_FB_POST_DATA(state, data) {
    state.fbPostData = data;
  }
};
